import React from 'react';

import { AccordionDetails } from '@material-ui/core';

import { StyledAccordion, StyledAccordionSummary } from './Accordion.styles';
import { Icons } from '../../..';

export interface AccordionProps {
  id?: string;
  headerContent: string | React.ReactNode;
  dataQaId?: string;
  defaultExpanded?: boolean;
  disabled?: boolean;
  expanded?: boolean;
  onClick?: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  id,
  headerContent,
  children,
  dataQaId,
  defaultExpanded,
  disabled,
  expanded,
  onClick,
}) => {
  return (
    <StyledAccordion
      key={id}
      role="heading"
      aria-level={1}
      data-qa-id={`${dataQaId}-container`}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      expanded={expanded}
    >
      <StyledAccordionSummary
        expandIcon={<Icons.Arrow type="down" />}
        data-qa-id={`${dataQaId}-header`}
        onClick={onClick}
      >
        {headerContent}
      </StyledAccordionSummary>
      <AccordionDetails data-qa-id={`${dataQaId}-panel`}>{children}</AccordionDetails>
    </StyledAccordion>
  );
};

export default Accordion;
